import _ from 'lodash';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import numeral from 'numeral';
import { useEffect, useState } from 'react';
import Image from 'src/components/image';
import { APP_IMG, SHOW_COMMEMORATE } from 'src/constants';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';
const Carousel = dynamic(import('src/components/carousels/carousel-3d'));

const SectionHalfBookcase = ({ bookcaseHalf = [], eventDataLayer }) => {
  const backgroundDesktopRight = _.find(bookcaseHalf?.dataSet, { key: 'right-image-desktop' })?.value;
  const backgroundMobileRight = _.find(bookcaseHalf?.dataSet, { key: 'right-image-mobile' })?.value;
  const rightLink = _.find(bookcaseHalf?.dataSet, { key: 'right-link' })?.value || ''; // https://inews.bangkokbiznews.com/?isRegister=1
  const titleText = _.find(bookcaseHalf?.dataSet, { key: 'title-text' })?.value || 'i-newspaper';
  const buttonText = _.find(bookcaseHalf?.dataSet, { key: 'button-text' })?.value || 'สมัครสมาชิก';
  const sectionHeading = _.find(bookcaseHalf?.dataSet, { key: 'section-heading' })?.value || 'กรุงเทพธุรกิจ Digital';
  const isShowNine = _.find(bookcaseHalf?.dataSet, { key: 'show-nine-baht' })?.value || 'false';
  const router = useRouter();
  const [cloneData, setCloneData] = useState([]);
  useEffect(() => {
    const num = new Date().getDay() === 1 ? 28 : 24;
    const dataSrc = '/pdf/newspaper_daily/P';
    const more = 'https://inews.bangkokbiznews.com';
    const _cloneData = [...Array(24)].slice(0, num).map((item, index) => {
      return (
        <a
          href={more}
          target='_blank'
          rel='noopener noreferrer nofollow'
          //! DATALAYER
          onClick={() =>
            sendDataLayerGlobal({
              ...eventDataLayer,
              data: {
                heading: `E-Book ${sectionHeading}`,
                title: `${more}${dataSrc}${numeral(index + 1).format('00')}.jpg`,
                carousel: index + 1
              }
            })
          }
        >
          <Image image={`${dataSrc}${numeral(index + 1).format('00')}.jpg`} type='CARD_MEDIUM' />
        </a>
      );
    });
    setCloneData(_cloneData);
  }, []);
  return (
    <>
      {!_.isEmpty(bookcaseHalf) && (
        <SectionHalfBookcaseNews className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
          {/* backgroundImageRight={{desktop: backgroundDesktopRight, mobile: backgroundMobileRight}} rightLink={rightLink} */}
          {/* Flip Image Section bookcase */}
          {/* <Script src='//static.fliphtml5.com/web/js/plugin/LightBox/js/fliphtml5-light-box-api-min.js' strategy='afterInteractive' /> */}
          <div className='container section-half-bookcase'>
            <div className='block-wrapper'>
              <div className='block-title'>
                <h2>{sectionHeading}</h2>
              </div>
            </div>
            <Carousel isHtml={true} slides={cloneData} />
            {!_.isEmpty(cloneData) ? (
              <div className='banner-case-bg'>
                <img src={`${APP_IMG}/static/bookcase/bg-desktop.png`} alt='bookcase-desktop' width='100%' height='100%' className='bg-desktop' />
                <img src={`${APP_IMG}/static/bookcase/bg-mobile.png`} alt='bookcase-desktop' width='100%' height='100%' className='bg-mobile' />
              </div>
            ) : null}
          </div>
          <a
            href={rightLink}
            className='image-right-wrapper'
            target='_blank'
            // ! DATALAYER
            onClick={() =>
              sendDataLayerGlobal({
                ...eventDataLayer,
                data: {
                  block: '2',
                  title: 'สมัครสมาชิก iNews',
                  heading: 'iNews'
                }
              })
            }
          >
            {!_.isEmpty(backgroundDesktopRight) ? <img className='right-image desktop' src={backgroundDesktopRight} /> : null}
            {!_.isEmpty(backgroundMobileRight) ? <img className='right-image mobile' src={backgroundMobileRight} /> : null}
            {_.isEmpty(backgroundDesktopRight) && _.isEmpty(backgroundMobileRight) ? (
              <DefaultRight className='default-background'>
                <div className='text'>
                  {titleText}{' '}
                  {isShowNine === 'true' ? (
                    <div class='sub-text'>
                      เพียงวันละ <strong>9</strong> บาท
                    </div>
                  ) : null}
                </div>
                <img className='image' src={`${APP_IMG}/images/inews-paper-asset.png`} />
                <button className='button'>{buttonText}</button>
              </DefaultRight>
            ) : null}
          </a>
        </SectionHalfBookcaseNews>
      )}
    </>
  );
};
const SectionHalfBookcaseNews = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  padding: 30px 0;
  @media (max-width: 767px) {
    flex-direction: column;
  }
  .react-3d-carousel {
    margin: auto auto -16px auto;
    min-height: 340px;
    @media (max-width: 475px) {
      margin: auto auto -5vw auto;
      min-height: 330px;
    }
  }
  .banner-case-bg {
    position: relative;
    z-index: -1;
  }
  .block-wrapper {
    margin-bottom: 20px;
  }
  .section-half-bookcase {
    width: 64%;
    padding-left: unset;
    padding-right: unset;
    height: auto;
    min-height: 340px;
    @media (max-width: 767px) {
      width: 100%;
    }
    @media (max-width: 480px) {
      min-height: 330px;
    }
    .slider-heading {
      display: none;
    }
    /* .slider-card {
        display: block !important;
        width: 90% !important;
        max-width: 300px;
        margin: 1rem;
        padding: 10px;

        img {
        width: 100%;
        height: 100%;
        box-shadow: 2px 3px 7px rgba(0, 0, 0, 0.2);
        &:hover {
            transform: scale(1.1);
            transition: 0.5s;
        }
        }
    } */
    button {
      cursor: pointer;
      display: flex !important;
      opacity: 0.4;
      background-color: #000;
      position: absolute;
      text-align: center;
      border-radius: 50%;
      justify-content: center;
      align-items: center;
      padding: 16px 15px 14.5px 15px;

      &:hover,
      &:focus {
        background: #0600e7 !important;
      }
    }

    .slick-next {
      right: -15px !important;
      z-index: 25 !important;
    }

    .slick-prev {
      left: -15px !important;
      z-index: 25 !important;
    }
  }
  .image-right-wrapper {
    width: 34%;
    display: flex;
    align-items: center;
    @media (max-width: 767px) {
      width: 100%;
    }
    .right-image {
      width: 100%;
      height: auto;
      &.desktop {
        display: block;
        @media (max-width: 767px) {
          display: none;
        }
      }
      &.mobile {
        display: none;
        @media (max-width: 767px) {
          display: block;
        }
      }
    }
  }
`;

const DefaultRight = styled.div`
  width: 100%;
  aspect-ratio: 1/1;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 15px 0;
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  @media (max-width: 767px) {
    box-shadow: unset;
    border-radius: unset;
  }
  .text {
    color: #0600e7;
    width: 100%;
    text-align: center;
    font-size: 25px;
    font-weight: 400;
    line-height: 1.3;
    padding: 0 15px;
    @media (max-width: 767px) {
      font-size: 22px;
      width: 345px;
    }

    /* @media (max-width: 992px) {
          font-size: 26px;
          font-weight: 500;
        }
        @media (max-width: 767px) {
          font-size: 30px;
        }
        @media (max-width: 475px) {
          font-size: 30px;
        } */
    .sub-text {
      margin-top: 5px;
    }
    strong {
      display: inline-block;
      color: red;
      margin-top: -15px;
      font-size: 30px;
    }
  }
  .image {
    width: 100%;
    max-width: 350px;
    margin-bottom: -5px;
  }
  .button {
    width: fit-content;
    padding: 5px 10px;
    border-radius: 15px;
    background-color: #0600e7;
    color: #fff;
    font-size: 20px;
    transition: all 0.2s ease-out;
    border: 3px solid #0600e7;
    font-weight: 400;
    &:hover {
      color: #0600e7;
      background-color: #fff;
    }
  }
`;
export default SectionHalfBookcase;
